import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { LoadingBackdrop } from 'components/common'
import { Mode } from 'constants/index'
import {
  useGetDriverQuery,
  CreateAndUpdateDriverDtoInput,
  useGetDriverForSupplierQuery,
} from 'generated/graphql'
import { usePermission } from 'providers/PermissionProvider/usePermission'

import DriverFormControls from './DriverFormControls'

interface IProps {
  driverId: number
  isProcessing: boolean
  onWarningAvailable?: (warning: string) => void
}

const UpdateDriver = (props: IProps) => {
  const { driverId, isProcessing, onWarningAvailable } = props
  const { reset } = useFormContext<CreateAndUpdateDriverDtoInput>()

  const [isAllowedToViewEditXeroPurchaseCode] = usePermission('ViewEditXeroPurchaseCode')
  const queryHook = isAllowedToViewEditXeroPurchaseCode
    ? useGetDriverQuery
    : useGetDriverForSupplierQuery

  // Queries
  const {
    data: driverData,
    loading: driverLoading,
    refetch: driverDataRefetch,
  } = queryHook({
    variables: { driverId },
    skip: !driverId,
  })

  useEffect(() => {
    if (driverId) {
      driverDataRefetch({ driverId })
    }
  })

  useEffect(() => {
    if (driverData?.driver && !driverLoading) {
      const driver = driverData.driver

      reset({
        ...driver,
        vatCategoryId: driver.vatCategoryId ?? '',
        ...(isAllowedToViewEditXeroPurchaseCode && 'xeroPurchaseCode' in driver
          ? { xeroPurchaseCode: driver.xeroPurchaseCode ?? '' }
          : {}),
      })
    }
  }, [driverData, reset, driverLoading, isAllowedToViewEditXeroPurchaseCode])

  useEffect(() => {
    if (driverData?.driver && onWarningAvailable) {
      const warning = driverData.driver.driverUserStatusMessage
      if (warning) {
        onWarningAvailable(warning)
      }
    }
  }, [driverData, onWarningAvailable])

  return (
    <>
      <DriverFormControls driverId={driverId} mode={Mode.Update} isProcessing={isProcessing} />
      <LoadingBackdrop loading={driverLoading} />
    </>
  )
}

export default UpdateDriver
